import type { MouseEventHandler, ReactNode } from 'react'

import type { WithLoadingState } from '@eshop/type'

import css from './index.module.css'

import { type Resolution, Image } from '#/global/component/Image/Image'

import linkTo from '#/global/helper/LinkTo'

interface Product {
    code: string
    detail: {
        image?: string
        slug: string
        title: string
        titleShort?: string
    }
    type: 'eshop' | 'rental' | 'season'
}

interface Props {
    AdditionalInfo?: ReactNode
    AddToCart: ReactNode
    Availability?: ReactNode
    onClick?: MouseEventHandler<HTMLAnchorElement>
    product: Product
    ProductPrice: ReactNode
}

export const ProductPreviewLong = ({
    AdditionalInfo,
    AddToCart,
    Availability,
    loadingState,
    onClick,
    product,
    ProductPrice,
}: WithLoadingState<Props>) => {
    const resolution: Resolution[] = [
        { width: 290, height: 225 },
        { width: 160, height: 160, maxWidth: 360 },
        { width: 190, height: 190, maxWidth: 420 },
        { width: 307, height: 307, maxWidth: 650 },
        { width: 350, height: 350, maxWidth: 740 },
        { width: 307, height: 307, maxWidth: 980 },
    ]

    if (loadingState) {
        return (
            <div className={`r-product-preview ${css.product}`}>
                <div>
                    <div className={`${css.img} loading`}>
                        <Image resolutionList={resolution} />
                    </div>
                    <div className={`${css.title} loading`} />
                </div>
                <div>
                    <div className={`${css.priceLoadingWrap} loading`} />
                    <div className={`${css.addToCartLoadingWrap} loading`} />
                </div>
            </div>
        )
    }

    const link = linkTo(`product-${product.type}`, product.code, product.detail.slug)

    return (
        <div className={`r-product-preview ${css.product}`}>
            <div>
                <a className={css.img} href={link} onClick={onClick}>
                    {AdditionalInfo}
                    <Image src={product.detail.image} alt={product.detail.titleShort ?? product.detail.title} resolutionList={resolution} />
                </a>
                <a className={css.title} href={link} onClick={onClick}>
                    <div>{product.detail.titleShort ?? product.detail.title}</div>
                </a>
            </div>
            <div>
                {ProductPrice}
                {Availability}
                {AddToCart}
            </div>
        </div>
    )
}
